"use client";
import { DotsHorizontalIcon } from "@radix-ui/react-icons";
import { Row } from "@tanstack/react-table";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { opportunitySchema } from "../table-data/schema";
import { useRouter } from "next/navigation";
import { useState } from "react";
import { useToast } from "@/components/ui/use-toast";
import axios from "axios";
import RightViewModalNoTrigger from "@/components/modals/right-view-notrigger";
import { UpdateOpportunityForm } from "../components/UpdateOpportunityForm";

interface DataTableRowActionsProps<TData> {
  row: Row<TData>;
}

export function DataTableRowActions<TData>({
  row,
}: DataTableRowActionsProps<TData>) {
  const router = useRouter();
  const opportunity = opportunitySchema.parse(row.original);
  const [updateOpen, setUpdateOpen] = useState(false);
  const { toast } = useToast();

  const onHideToggle = async () => {
    try {
      const response = await axios.put(`/api/crm/opportunity/hide/${opportunity?.id}`);
      toast({
        title: "Success",
        description: response.data.message,
      });
      router.refresh();
    } catch (error) {
      toast({
        variant: "destructive",
        title: "Error",
        description: "Something went wrong while toggling visibility. Please try again.",
      });
    }
  };

  return (
    <div className="flex items-center space-x-2">
      <Button
        variant="outline"
        onClick={() => router.push(`/crm/leads/${opportunity?.assigned_leadsIDs}`)}
      >
        View 
      </Button>

      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button
            variant="outline"
            className="flex h-8 w-8 p-0 data-[state=open]:bg-muted"
          >
            <DotsHorizontalIcon className="h-4 w-4" />
            <span className="sr-only">Open menu</span>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-[160px]">
          <DropdownMenuItem onClick={onHideToggle}>
            {opportunity.status === "INACTIVE" ? "Unhide" : "Hide"}
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}